/** Reports clipped tag text so its full wording remains available on hover. */
export const observeTagOverflow = (node: HTMLElement, onChange: (overflowing: boolean) => void) => {
  let disposed = false
  const measure = () => {
    if (disposed) return

    onChange(
      Array.from(node.querySelectorAll<HTMLElement>("span")).some(
        (element) => element.clientWidth > 0 && element.scrollWidth > element.clientWidth,
      ),
    )
  }
  const resizeObserver = typeof ResizeObserver === "undefined" ? null : new ResizeObserver(measure)
  resizeObserver?.observe(node)
  const mutationObserver = new MutationObserver(measure)
  mutationObserver.observe(node, { childList: true, characterData: true, subtree: true })
  queueMicrotask(measure)

  return {
    update(callback: typeof onChange) {
      onChange = callback
      queueMicrotask(measure)
    },
    destroy() {
      disposed = true
      resizeObserver?.disconnect()
      mutationObserver.disconnect()
    },
  }
}
